// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/routes/Dashboard/Dashboard.css */

.dashboard-container {
    display: flex;
    flex-direction: column;
    background-color: #f5f6fa;
    margin: 0;
    padding: 0;
    height: 100%;
    min-height: 0;
}

.header-boxes {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.info-boxes-row {
    display: flex;
    gap: 10px;
    width: 90%;
    margin: auto;
    margin-left: 0;
}

.info-box {
    background-color: rgba(52, 152, 219, 0.1);
    border-radius: 4px;
    padding: 4px 8px;
    color: #2c3e50;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    width: 100%;
}

.dashboard-content {
    display: flex;
    flex: 1 1;
    min-width: 0;
}

.dashboard-content--full {
    display: block;
    overflow: hidden;
}

.sidebar {
    width: 250px;
    background-color: #2c3e50;
    color: white;
    padding: 10px;
    display: flex;
    flex-direction: column;
}

.sidebar-teams, .sidebar-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.sidebar-teams h4, .sidebar-actions h4 {
    margin: 0;
    padding: 10px 0;
    color: #a0aec0;
    font-size: 1rem;
}

.sidebar-button {
    width: 100%;
    padding: 5px;
    background-color: #236b9a;
    border: none;
    border-radius: 6px;
    color: white;
    text-align: left;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 0.9rem;
}

.sidebar-button:hover:not(:disabled) {
    background-color: rgba(255, 255, 255, 0.1);
    transform: translateX(2px);
    color: white;
}

.sidebar-button.active {
    background-color: #EF6F53;
    color: white;
}

.sidebar-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
}

.teams-dropdown {
    position: relative;
    width: 100%;
}

.teamss-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
}

.teamm-itemm {
    display: block;
    width: 100%;
    padding: 2px;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    background-color: white;
    text-align: left;
    cursor: pointer;
    transition: all 0.2s ease;
}

.teamm-itemm.selected {
    background-color: #df9d9d;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.teamm-itemm:hover {
    background-color: #EF6F53;
    border-color: #d0d0d0;
    transform: translateY(-1px);
}

.teeam-namee {
    font-weight: 500;
    color: #236b9a;
    font-size: 14px;
}

.teeam-namee.active {
    background-color: #EF6F53;
    color: white;
}

.team-count {
    font-size: 0.9em;
    color: #EF6F53;
    margin-left: 8px;
}

.teams-loading, .no-teams {
    padding: 5px;
    text-align: center;
    color: #666;
}

.other-actions {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.main-contenttt {
    flex: 1 1;
    padding: 5px;
    overflow-y: auto;
    min-width: 0;
    background-color: white;
    border-radius: 5px;
    margin: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.dashboard-content--full .main-contenttt {
    width: calc(100% - 10px);
    height: calc(100% - 10px);
    overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/routes/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA,kDAAkD;;AAElD;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,SAAS;IACT,UAAU;IACV,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;IAC1C,0BAA0B;IAC1B,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,gBAAgB;AACpB","sourcesContent":["/* src/components/routes/Dashboard/Dashboard.css */\n\n.dashboard-container {\n    display: flex;\n    flex-direction: column;\n    background-color: #f5f6fa;\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    min-height: 0;\n}\n\n.header-boxes {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.info-boxes-row {\n    display: flex;\n    gap: 10px;\n    width: 90%;\n    margin: auto;\n    margin-left: 0;\n}\n\n.info-box {\n    background-color: rgba(52, 152, 219, 0.1);\n    border-radius: 4px;\n    padding: 4px 8px;\n    color: #2c3e50;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    width: 100%;\n}\n\n.dashboard-content {\n    display: flex;\n    flex: 1;\n    min-width: 0;\n}\n\n.dashboard-content--full {\n    display: block;\n    overflow: hidden;\n}\n\n.sidebar {\n    width: 250px;\n    background-color: #2c3e50;\n    color: white;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n}\n\n.sidebar-teams, .sidebar-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.sidebar-teams h4, .sidebar-actions h4 {\n    margin: 0;\n    padding: 10px 0;\n    color: #a0aec0;\n    font-size: 1rem;\n}\n\n.sidebar-button {\n    width: 100%;\n    padding: 5px;\n    background-color: #236b9a;\n    border: none;\n    border-radius: 6px;\n    color: white;\n    text-align: left;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    font-size: 0.9rem;\n}\n\n.sidebar-button:hover:not(:disabled) {\n    background-color: rgba(255, 255, 255, 0.1);\n    transform: translateX(2px);\n    color: white;\n}\n\n.sidebar-button.active {\n    background-color: #EF6F53;\n    color: white;\n}\n\n.sidebar-button:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.teams-dropdown {\n    position: relative;\n    width: 100%;\n}\n\n.teamss-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 8px;\n}\n\n.teamm-itemm {\n    display: block;\n    width: 100%;\n    padding: 2px;\n    border: 1px solid #e0e0e0;\n    border-radius: 6px;\n    background-color: white;\n    text-align: left;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.teamm-itemm.selected {\n    background-color: #df9d9d;\n    transform: translateY(-1px);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.teamm-itemm:hover {\n    background-color: #EF6F53;\n    border-color: #d0d0d0;\n    transform: translateY(-1px);\n}\n\n.teeam-namee {\n    font-weight: 500;\n    color: #236b9a;\n    font-size: 14px;\n}\n\n.teeam-namee.active {\n    background-color: #EF6F53;\n    color: white;\n}\n\n.team-count {\n    font-size: 0.9em;\n    color: #EF6F53;\n    margin-left: 8px;\n}\n\n.teams-loading, .no-teams {\n    padding: 5px;\n    text-align: center;\n    color: #666;\n}\n\n.other-actions {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.main-contenttt {\n    flex: 1;\n    padding: 5px;\n    overflow-y: auto;\n    min-width: 0;\n    background-color: white;\n    border-radius: 5px;\n    margin: 5px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.dashboard-content--full .main-contenttt {\n    width: calc(100% - 10px);\n    height: calc(100% - 10px);\n    overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
